import { MirrorStandardSettings } from 'apps/studio/components/settings/fields/Mirror/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const MirrorSettings = [
  FieldSettingsPanel(MirrorStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
